import { useQuery } from "@tanstack/react-query";
import { orgBillingApi } from "@/api/org-billing-api";
import { useActiveOrg } from "@/hooks/use-active-org";
import type { InvoicesResponse } from "@/api/billing-api";

export function useOrgInvoices() {
  const { orgId } = useActiveOrg();

  const { data, isLoading, error } = useQuery<InvoicesResponse>({
    queryKey: ["orgInvoices", orgId],
    queryFn: () => {
      if (!orgId) {
        return { invoices: [], has_more: false, last_invoice_id: null };
      }
      return orgBillingApi.getInvoices(orgId);
    },
    enabled: !!orgId,
    staleTime: 60 * 1000,
  });

  return {
    invoices: data?.invoices ?? [],
    hasMore: data?.has_more ?? false,
    isLoading,
    error,
  };
}
